import { format } from 'date-fns'
import { BlankType, CharSize } from 'generated/graphql'

export const getBytes = (target) => {
  let b, i, c
  for (
    b = i = 0;
    (c = target.charCodeAt(i++));
    b += c >> 11 ? 3 : c >> 7 ? 2 : 1
  );
  return b
}

const TIME_ZONE = 3240 * 10000
export const formatCreatedAt = (date: number) => {
  try {
    const formattedCreatedAt = new Date(date + TIME_ZONE)
      .toISOString()
      .replace('T', ' ')
      .replace(/\..*/, '')
      .slice(0, 16)

    return formattedCreatedAt
  } catch (error) {
    return '-'
  }
}

export const formatBlankType = (data: BlankType) => {
  return data === BlankType.WITH_BLANK ? '공백포함' : '공백제외'
}

export const formatCharMaxSize = (data: CharSize) => {
  if (data === CharSize.CHAR) return '글자 수'
  if (data === CharSize.THREE_BYTE) return '3byte'
  if (data === CharSize.TWO_BYTE) return '2byte'
  return ''
}

export const formatDisplayedAt = (createdAt: number) => {
  const formattedCreatedAt = format(createdAt, 'yyyy.dd')
  const formattedNow = format(new Date(), 'yyyy.dd')

  if (formattedCreatedAt === formattedNow) {
    return format(createdAt, 'hh:mm')
  }

  const milliSeconds = new Date().getTime() - createdAt
  const seconds = milliSeconds / 1000
  if (seconds < 60) return `방금 전`
  const minutes = seconds / 60
  if (minutes < 60) return `${Math.floor(minutes)}분 전`
  const hours = minutes / 60
  if (hours < 24) return `${Math.floor(hours)}시간 전`
  const days = hours / 24
  if (days < 7) return `${Math.floor(days)}일 전`
  const weeks = days / 7
  if (weeks < 5) return `${Math.floor(weeks)}주 전`
  const months = days / 30
  if (months < 12) return `${Math.floor(months)}개월 전`
  const years = days / 365
  return `${Math.floor(years)}년 전`
}

const byteCounter = (text, sum) => {
  let byte = 0
  for (let i = 0; i < text.length; i++) {
    if (/[ㄱ-ㅎㅏ-ㅣ가-힣一-龥ぁ-ゔァ-ヴー々〆〤]/.test(text[i])) {
      byte = byte + sum
    } else {
      byte++
    }
  }
  return byte
}

export const getAnswerLength = (
  answer: string,
  blankType: BlankType,
  charSize: CharSize,
) => {
  if (blankType === BlankType.WITH_BLANK) {
    //
  }
  if (blankType === BlankType.WITHOUT_BLANK) {
    answer = answer.replace(/(\s*)/g, '')
  }

  if (charSize === CharSize.CHAR) {
    return answer.length
  } else if (charSize === CharSize.TWO_BYTE) {
    const bytes = byteCounter(answer, 2)
    return bytes
  } else if (charSize === CharSize.THREE_BYTE) {
    const bytes = byteCounter(answer, 3)
    return bytes
  }
  return 0
}
